import * as types from './mutation-types';
import API from '@/services/commonApi';
import { USERS, PROJECTRMDETAILS, CUSTOMERSANDBROKERSLIST, AGENTCUSTOMERS, GETDRMLIST, GETDEVLIST, OTHERUSEERS, BROKERAPPROVALS, BROKERREMARK } from '@/utils/endpoint';

const actions = {
  getUsers: ({ commit }) => {
    API.get(USERS)
      .then((response) => {
        commit(types.USERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  storeFormulaData: ({ commit }, payload) => {
    commit(types.STOREFORMULADATA, payload);
  },
  removeFormulaData: ({ commit }) => {
    commit(types.REMOVEFORMULADATA);
  },
  getCustomersAndBrokers: ({ commit }, payload) => {
    if (payload && payload.id) {
      API.get(`${CUSTOMERSANDBROKERSLIST}${payload.id}/`)
        .then((response) => {
          commit(types.CUSTOMERSANDBROKERSLIST, response);
          if (payload && payload.cbSuccess)
            payload.cbSuccess();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      API.get(CUSTOMERSANDBROKERSLIST)
        .then((response) => {
          commit(types.CUSTOMERSANDBROKERSLIST, response);
          if (payload && payload.cbSuccess)
            payload.cbSuccess();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  getDrms: ({ commit }) => {
    API.get(GETDRMLIST)
      .then((response) => {
        commit(types.DRMLIST, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getDevs: ({ commit }) => {
    API.get(GETDEVLIST)
      .then((response) => {
        commit(types.DEVLIST, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  assignRmToUser: ({ _commit }, payload) => {
    API.post(`${AGENTCUSTOMERS}${payload.userId}/`, { project_id: payload.projectId })
      .then((response) => {
        payload.cbSuccess(response);
      })
      .catch((error) => {
        payload.cbError(error);
      });
  },
  getOtherUsers: ({ commit }, payload) => {
    /* eslint-disable max-len */
    let apiUrl = OTHERUSEERS;
    if (payload.projectId)
      apiUrl = `${OTHERUSEERS}${payload.type}/${payload.dev_id}/${payload.projectId}/`;
    else if (payload.dev_id && !payload.projectId)
      apiUrl = `${OTHERUSEERS}${payload.type}/${payload.dev_id}/`;
    else
      apiUrl = `${OTHERUSEERS}${payload.type}/`;
    API.get(apiUrl)
      .then((response) => {
        commit(types.OTHERUSER, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getRmDetails: ({ commit }, payload) => {
    API.get(`${PROJECTRMDETAILS}${payload.id}/`)
      .then((response) => {
        commit(types.PROJECTRMDETAILS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getBrokerDetails: ({ commit }) => {
    API.get(BROKERAPPROVALS)
      .then((response) => {
        commit(types.BROKERAPPROVALS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  reviewBroker: ({ _commit }, payload) => {
    API.put(BROKERREMARK, payload.data)
      .then(() => {
        if (payload.cb_success)
          payload.cb_success();
      })
      .catch((error) => {
        if (payload.cb_error)
          payload.cb_error(error);
        console.log(error);
      });
  },
  editUsers: ({ dispatch }, payload) => {
    API.put(USERS, payload)
      .then(() => {
        dispatch('getUsers');
        if (payload.cb_success)
          payload.cb_success();
      })
      .catch((error) => {
        if (payload.cb_error)
          payload.cb_error(error);
        console.log(error);
      });
  },
  deleteUser: ({ dispatch }, payload) => {
    API.delete(USERS, payload.userId)
      .then(() => {
        dispatch('getUsers');
      })
      .catch((error) => {
        payload.cbError(error);
        console.log(error);
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js